import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation UpdateLongFormBuilderProject($id: ID!, $title: String!, $titleScore: Int) {
    updateLongFormBuilderProject(id: $id, title: $title, titleScore: $titleScore) {
      id
    }
  }
`;

export const updateLongFormBuilderProject = ({ id, title, titleScore }) => {
  return executeGqlMutation({
    mutation: MUTATION,
    variables: {
      id,
      title,
      titleScore,
    },
  }).then(({ data }) => getSingleProp(data));
};
